import React from 'react'
import { makeStyles, Switch } from '@material-ui/core'
import { useObserver } from 'mobx-react-lite'
import { CentricTypography as Typography } from '@core/component/CentricTypography'
import { useTranslation } from 'react-i18next'
import map from 'lodash/map'
import SAFilterCollapse from '../components/CNFProductFilterCollapse'
import isEmpty from 'lodash/isEmpty'
import classNames from 'classnames'
import { CNFProductFilterChips } from '../components/CNFProductFilterChips'
import { CNFProductFilterTopBar } from '../components/CNFProductFilterTopBar'
import { NoRecordFound } from '@components/UI-Components/NoRecordFound'
import { stores } from '@stores'
import { ClearIcon } from '@core/icons'

const useStyles = makeStyles(theme => ({
  headerContainer: {
    backgroundColor: '#FAFAFA'
  },
  header: {
    padding: '25px 25px 5px',
    display: 'flex',
    justifyContent: 'space-between'
  },
  filterBody: {
    height: `calc(100% - 170px)`,
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      display: 'none'
    }
  },
  switchWrapper: {
    display: 'flex',
    alignItems: 'center',
    padding: '12px 15px'
  },
  showSelected: {
    padding: '12px 15px 6px'
  },
  clearIcon: {
    cursor: 'pointer'
  }
}))

export const CNFProductFilterContainer = ({ onApply, filterStore, onClose }) => {
  return useObserver(function useHook() {
    const { t } = useTranslation()
    const classes = useStyles()
    const {
      filterValues,
      filterAttributes,
      filterLoading,
      expanded,
      selected,
      clearFilter,
      clearAllFilter,
      excludedFilters,
      handleFilterSelection,
      handleShowSelected,
      handleFilterExpansion,
      handleFilterExclusion,
      handleAllFilterExpansion,
      onFilterSearchKeyChange,
      isShowSelected,
      getSearchedData,
      filterSearchKey,
      totalFilterSelectionCount
    } = filterStore

    const {
      productConfiguration: { defaultValuesFromConfig }
    } = stores

    const searchedFilterValues = !!filterSearchKey
      ? getSearchedData(filterValues, filterSearchKey)
      : filterValues

    return (
      <>
        <div className={classes.headerContainer}>
          <div className={classes.header}>
            <Typography variant='h4'>{t('common.label.filter', 'Filter')}</Typography>
            <div className={classes.clearIcon} onClick={onClose}>
              <ClearIcon />
            </div>
          </div>
          <CNFProductFilterTopBar
            clearAllFilter={() => {
              clearAllFilter()
              onApply()
            }}
            handleFilterExpansion={handleAllFilterExpansion}
            onSearchKeyChange={onFilterSearchKeyChange}
            filterSearchKey={filterSearchKey}
            hasFilters={!isEmpty(selected)}
          />
        </div>
        <div
          className={classNames(
            classes.switchWrapper,
            !isEmpty(selected) && isShowSelected && classes.showSelected
          )}
        >
          <Switch size='small' onChange={handleShowSelected} />
          <Typography variant='body1'>
            {t('common.label.showSelectedFirst', 'Show Selected First')}
            {totalFilterSelectionCount ? ` (${totalFilterSelectionCount})` : ''}
          </Typography>
        </div>
        {!filterLoading && !isEmpty(searchedFilterValues) ? (
          <div className={classes.filterBody} id='filterBody'>
            {!isEmpty(selected) && isShowSelected && (
              <CNFProductFilterChips
                selectedFilters={selected}
                defaultEmptyText={defaultValuesFromConfig?.empty}
                clearFilter={filterId => {
                  clearFilter(filterId)
                  onApply()
                }}
                filterAttributes={filterAttributes}
                removeFilter={(checked, filterValue, filterId) => {
                  handleFilterSelection(checked, filterValue, filterId)
                  onApply()
                }}
              />
            )}
            {map(filterAttributes, (filter: any) =>
              searchedFilterValues?.[filter?.id]?.length ? (
                <div key={filter?.id}>
                  <SAFilterCollapse
                    filterId={filter?.id}
                    collapsibleName={t(filter?.labelKey, filter?.displayName)}
                    values={searchedFilterValues?.[filter?.id] ?? []}
                    handleFilterSelection={(checked, filterValue, filterId) => {
                      handleFilterSelection(checked, filterValue, filterId)
                      onApply()
                    }}
                    selectedFilter={selected}
                    clearFilter={filterId => {
                      clearFilter(filterId)
                      onApply()
                    }}
                    handleFilterExclusion={(filterValue, filterId) => {
                      handleFilterExclusion(filterValue, filterId)
                      onApply()
                    }}
                    excludedFilters={excludedFilters}
                    handleFilterExpansion={handleFilterExpansion}
                    expanded={!!expanded.includes(filter?.id)}
                    filterStore={filterStore}
                    defaultEmptyText={defaultValuesFromConfig?.empty}
                  />
                </div>
              ) : null
            )}
          </div>
        ) : (
          <div style={{ margin: 20 }}>
            <NoRecordFound />
          </div>
        )}
      </>
    )
  })
}
